<script setup lang="ts">
import { RouterLink, RouterView, useRouter } from "vue-router";
import { useLogto } from "@logto/vue";
import { callbackUrl, postSignOutUrl } from "./logto";

const { isAuthenticated, signIn, signOut } = useLogto();
const router = useRouter();

async function handleLogin() {
  await signIn(callbackUrl);
}

async function handleLogout() {
  await signOut(postSignOutUrl);
  router.push("/");
}
</script>

<template>
  <header class="topbar">
    <RouterLink to="/" class="brand">Imprint</RouterLink>
    <nav>
      <RouterLink v-if="isAuthenticated" to="/dashboard">Dashboard</RouterLink>
      <button v-if="!isAuthenticated" class="link-btn" @click="handleLogin">Login</button>
      <button v-else class="link-btn" @click="handleLogout">Logout</button>
    </nav>
  </header>
  <main class="container">
    <RouterView />
  </main>
  <footer class="footer">
    <p>Imprint — tool-agnostic memory for AI coding assistants.</p>
  </footer>
</template>

<style scoped>
.topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 2rem;
  border-bottom: 1px solid var(--border);
  background: white;
}
.brand {
  font-weight: 700;
  color: var(--brand);
  text-decoration: none;
  font-size: 1.25rem;
}
nav {
  display: flex;
  gap: 1.5rem;
  align-items: center;
}
nav a {
  color: var(--text-muted);
  text-decoration: none;
}
nav a.router-link-active {
  color: var(--brand);
}
.link-btn {
  background: none;
  border: none;
  color: var(--text-muted);
  cursor: pointer;
  padding: 0;
  font: inherit;
}
.link-btn:hover {
  background: none;
  color: var(--brand);
}
.container {
  max-width: 960px;
  margin: 0 auto;
  padding: 2rem;
  min-height: calc(100vh - 130px);
}
.footer {
  text-align: center;
  padding: 1rem;
  color: var(--text-muted);
  font-size: 0.875rem;
}
</style>
